
import {
  http,
  makeURL,
} from 'counselor-mobile-ui/utils/feature/http'
import { getPlatform } from 'counselor-sdk/lib/utils/platform'
import router from '../router'

const errorMsgObj = { 2210070006: '已被发布者删除、撤回' }

http.use('response', (response) => {
  const { code } = response
  const errMsg = errorMsgObj[code]

  if (errMsg) {
    router.replace({
      path: '/page-empty',
      query: { errorText: errMsg },
    })
  }

  return response
})

export const queryConfigURL = makeURL('/leave/stu/jssdk/queryConfig')
export function queryConfig (...args) {
  return http.post(queryConfigURL, {
    url: window.location.href.split('#')[0],
    platform: getPlatform(),
  })
}

export const getShareDetailURL = makeURL('leave/share/detail')
export function getShareDetail (...args) {
  return http.post(getShareDetailURL, ...args)
}

export const getLeaveQrURL = makeURL('/leave/stu/getLeaveQr')
export function getLeaveQr (...args) {
  return http.post(getLeaveQrURL, ...args)
}
